import { v4 as uuidv4 } from 'uuid';

export const phoneNum = '';
export const signatureList = [
    { value: 1, name: "No Signature required" },
    { value: 2, name: "Signature required" },
    { value: 3, name: "Adult Signature required" },
];

export const dangerousGoods = [
    { value: 1, name: "Primary Contained" },
    { value: 2, name: "Primary Packed" },
    { value: 3, name: "Primary" },
    { value: 4, name: "Secondary Contained" },
    { value: 5, name: "Secondary Packed" },
    { value: 6, name: "Secondary" },
    { value: 7, name: "ORMD" },
    { value: 8, name: "Limited Quantity" },
    { value: 9, name: "Lithium" },
];

export const accountTransactionType = {
    TRANSACTION_PAYMENT: 8
};

export const NOTIFICATION_FETCH_INTERVAL = 180000; // 3 minutes
export const validUsZip = /^\d{5}(-\d{4})?$/;
export const validateMultipleEmails = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const passwordRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9]).{10,}$/;
export const passwordMinRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9]).{8,15}$/;
export const amountRegex = /^([1-9]\d*|0)(\.\d*)?$/;

export const SHIPVISION_AI_CONFIG = 'shipvisionai.com';

const currentUrl = window.location.href;
let findApiUrl;

if (currentUrl) {
    if (currentUrl.includes('wms-dev')) {
        findApiUrl = 'https://wms-api.compunnel.com';
    } else if (currentUrl.includes('wms-qa')) {
        findApiUrl = 'https://wmsqa-api.compunnel.com';
    } else if (currentUrl.includes('3plvision')) {
        findApiUrl = 'https://prod-api.3plvision.com';
    } else if (currentUrl.includes('dev.shipvisionai.com')) {
        findApiUrl = 'https://dev-api.shipvisionai.com';
    } else if (currentUrl.includes('qa.shipvisionai.com')) {
        findApiUrl = 'https://qa-api.shipvisionai.com';
    } else if (currentUrl.includes('uat.shipvisionai.com')) {
        findApiUrl = 'https://uat-api.shipvisionai.com';
    } else if (currentUrl.includes('portal.shipvisionai.com')) {
        findApiUrl = 'https://prod-api.shipvisionai.com';
    } else if (currentUrl.includes('wms-uat')) {
        findApiUrl = 'https://wmsuat-api.compunnel.com';
    } else {
        findApiUrl = 'https://wms-api.compunnel.com';
    }
} else {
    findApiUrl = 'https://wms-api.compunnel.com';
}

export const apiUrl = findApiUrl;

let marketPlaceEndPoint;

if (currentUrl) {
    if (currentUrl.includes('3plvision') || currentUrl.includes('shipvisionai')) {
        marketPlaceEndPoint = 'https://bcar2yflal.execute-api.us-east-1.amazonaws.com'
    } else {
        marketPlaceEndPoint = 'https://5u1phqappa.execute-api.us-east-1.amazonaws.com'
    }
}

export const marketPlaceUrl = marketPlaceEndPoint;

export const paymentUrl = currentUrl &&
    (currentUrl.includes('3plvision') || currentUrl.includes('shipvisionai') || currentUrl.includes('wms-uat')) ? 'https://accept.authorize.net/payment/payment'
    : 'https://test.authorize.net/payment/payment';

let sampleTemplateForRateCard;
if (currentUrl) {
    if (currentUrl.includes('wms-dev')) {
        sampleTemplateForRateCard = 'https://wms-api.compunnel.com/upload/SellerRateCardTemplate.csv';
    } else if (currentUrl.includes('wms-qa')) {
        sampleTemplateForRateCard = 'https://wmsqa-api.compunnel.com/upload/SellerRateCardTemplate.csv';
    } else if (currentUrl.includes('wms-uat')) {
        sampleTemplateForRateCard = 'https://wmsuat-api.compunnel.com/upload/SellerRateCardTemplate.csv';
    } else if (currentUrl.includes('3plvision')) {
        sampleTemplateForRateCard = 'https://prod-api.3plvision.com/upload/SellerRateCardTemplate.csv';
    } else if (currentUrl.includes('shipvisionai')) {
        sampleTemplateForRateCard = 'https://prod-api.3plvision.com/upload/SellerRateCardTemplate.csv';
    } else {
        sampleTemplateForRateCard = 'https://wms-api.compunnel.com/upload/SellerRateCardTemplate.csv';
    }
} else {
    sampleTemplateForRateCard = 'https://wms-api.compunnel.com/upload/SellerRateCardTemplate.csv';
}

export const sampleTemplateRateCard = sampleTemplateForRateCard;

export const unitList = [
    { value: "INCH", name: "in / lb / oz", id: 1 },
    { value: "CMS", name: "cm / kg / g", id: 2 },
];

export const numOfPage = [30, 50, 100, 200, 500, 1000, 2000];
export const carrierConnectBizBlyIds = [276, 207]; // Bizbly Company IDs for Carrier Connect

export const allowedCSVExtension = ['csv'];
export const allowedPDFExtension = ['pdf'];
export const allowedExtensions = ['jpg', 'jpeg', 'png'];
export const allowedDocExtensions = ['xls', 'xlsx', 'csv', 'pdf', 'doc', 'docx', 'jpg', 'jpeg', 'png', 'svg'];
export const videoallowedExtensions = ["mp4", "avi", "mov"]
export const validEmailRe = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
export const numOnly = /\D/g;
export const trackingNum = /^[a-zA-Z0-9 -]*$/;

export const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const zipCodeRegex = /^\d{5}(-\d{4})?$/;
export const alphabeticKeys = /^[0-9-]$/;
export const alphabeticKeysReg = /^[A-Za-z]$/;

export const oneOunce = 0.453592;

export const userRoles = {
    admin: 1,
    seller: 2,
    superAdmin: 3,
    warehouseManager: 5,
    warehouseWorker: 6,
};

export const numOfSellerToDisplay = 2;

export const commodityObj = {
    includeCommercial: false,
    invoiceType: 0,
    taxIdVat: '',
    packageMarks: '',
    senderTaxIdVat: '',
    issuerCountryId: 0,
    issuerCountry: '',
    commodityList: [
        { unitValue: null, quantity: null, weight: null, ounces: null, description: '', hts: '', countryOriginId: 0, countryOrigin: '' },
    ]
}

export const shipmentStatusList = [
    { name: 'Shipped', id: 2 },
    { name: 'Booked', id: 1 },
    { name: 'In-Transit', id: 7 },
    { name: 'Delivered', id: 5 },
];

export const requestShipmentStatus = [
    { name: 'Cancellation In-Progress', id: 3, label: 'Cancellation In-Progress', value: 3 },
    { name: 'Refunded', id: 6, label: 'Refunded', value: 6 },
];

export const fulfilledBy = [
    { name: 'All', id: 1, label: 'All', value: 1 },
    { name: 'Warehouse', id: 2, label: 'Warehouse', value: 2 },
    { name: 'Self', id: 3, label: 'Self', value: 3 },
];

export const commonAddressObj = {
    "id": 0,
    "name": "",
    "company": "",
    "addressLine1": "",
    "addressLine2": "",
    "addressLine3": "",
    "city": "",
    "state": "",
    "zip": "",
    "countryId": 218,
    "phone": "+1",
    "isSender": true,
    "isReceiver": true,
    "companySellerId": 0,
    "userId": 0
};

export const consoleObject = {
    "id": 0,
    "consignmentNumber": "",
    "consignmentTypeId": 1,
    "trackingNumber": "",
    "subTrackingNumber": "",
    "length": '',
    "width": '',
    attachments: [],
    "height": '',
    "dimensionUnitId": 1,
    "weight": '',
    "weightUnitId": 1,
    "countryOfOrigin": "",
    "countryOfOriginId": 0,
    "carrierTypeId": "",
    "comments": "",
    "consignmentStatusId": 1,
};

export const outboundObject = {
    "consignmentId": 0,
    "outboundNumber": "",
    "consignmentNumber": "",
    "outboundStatusId": 1,
    "consignmentTypeId": 0,
    "quantity": 0,
    "subQuantity": 0,
    "subQuantityMessage": "",
    "tertiarySubQuantity": 0,
    "items": [],
    "carrierTypeId": 0,
    "serviceTypeId": 0,
    "packageTypeId": 0,
    "trackingNumber": "",
    "subTrackingNumber": "",
    "isGenerateLabel": true,
    "addressFirst": "",
    "addressSecond": "",
    "addressThird": "",
    "city": "",
    "state": "",
    "country_Id": 218,
    "zipCode": "",
    "phoneNumber": "+1",
    "company": "",
    "email": "",
    "comments": "",
    "shippingLabel": "",
    "carrierCompanyId": 0
}

export const filterPayload = {
    sortKey: '',
    sortOrder: '',
    pageNumber: '1',
    pageIndex: '1',
    pageSize: '30',
    min_order_quantity: '',
    max_order_quantity: '',
    date_min: '',
    date_max: '',
    integration_name_filter: '',
    type_filter: '',
    active_filter: '',
    action_type: '',
    CompanySellerId: '',
    integration_id: '',
    showFilter: false,
}

export const elementObj = {
    "attachments": [],
    "id": 0,
    "palleteId": 0,
    "boxId": 0,
    "itemId": 0,
    "externalReference": "",
    "name": "",
    "description": "",
    "quantity": '',
    "trackingNumber": null,
    "subTrackingNumber": null,
    "dimensionUnitId": 1,
    "weightUnitId": 1,
    "consignmentTypeId": 1,
    "comments": "",
    "productSKU": "",
    "shippingStatusId": 0,
    "expirationDate": "",
    "consignmentElements": [],
}

export const elementItemObj = {
    "attachments": [],
    "id": 0,
    "palleteId": 0,
    "boxId": 0,
    "itemId": 0,
    "externalReference": "",
    "name": "",
    "description": "",
    "quantity": '',
    "trackingNumber": null,
    "subTrackingNumber": null,
    "dimensionUnitId": 1,
    "weightUnitId": 1,
    "consignmentTypeId": 1,
    "comments": "",
    "productSKU": "",
    "shippingStatusId": 0,
    "expirationDate": "2024-02-03T04:20:04.373",
    "consignmentElements": [{
        consignmentElements: []
    }],
}

export const shippingStatusList = [
    { value: 1, name: "Stored At WareHouse" },
    { value: 2, name: "Shipped Out" },
];

export const shippingStatusListconn = [
    { value: 0, name: "Select Status" },
    { value: 1, name: "Stored At WareHouse" },
    { value: 2, name: "Shipped Out" },
];

export const connectionOption = [
    { value: 1, name: "Stored At WareHouse" },
    { value: 2, name: "Shipped Out" },
];

export const deleteIcon = () => {
    return <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="currentColor"
        className="bi bi-trash"
        viewBox="0 0 16 16"
        color="red"
        cursor="pointer"
    >
        <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
        <path
            fillRule="evenodd"
            d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
        />
    </svg>
}

export const orderBarCodeList = [
    { name: 'None', id: 0 },
    { name: 'Order Number', id: 1 },
    { name: 'Shipper Reference', id: 2 },
    { name: 'Receiver Name', id: 3 },
];

export const barcodeList = [
    {
        name: "Barcode Mapping",
        icon: "fa fa-file-code-o",
        color: "#0000ff",
        path: "/barcode/mappings",
        permissionFor: "barcodeMapping",
        subModule: 23
    },
    {
        name: "Barcode Upload",
        icon: "fa fa-code",
        color: "#4BBBD3",
        path: "/barcode/barcode-upload",
        permissionFor: "barcodeUpload",
        subModule: 24
    },
    {
        name: "Barcode Settings",
        icon: "fa fa-qrcode",
        color: "#D04545",
        path: "/barcode-settings",
        permissionFor: "barcodeSettings",
        subModule: 25,
    },
    {
        name: "New Barcode Generation",
        icon: "fa fa-file-excel-o",
        color: "#0000ff69",
        path: "/generate-barcode",
        permissionFor: "newBarcodeGeneration",
        subModule: 26,
    },
    {
        name: "Adhoc Barcode Generation",
        icon: "fa fa-file-code-o",
        color: "#0000ff",
        path: "/barcode/adhoc-barcode-generation",
        permissionFor: "adhocBarcodeGeneration",
        subModule: 27,
    },
    {
        name: "Print by Order Number",
        icon: "fa fa-file-code-o",
        color: "#0000ff",
        path: "/barcode/print-by-order-number",
        permissionFor: "adhocBarcodeGeneration",
        subModule: 27,
    },
    {
        name: "Order Label Barcode Setting",
        icon: "fa fa-file-code-o",
        color: "#0000ff",
        path: "/barcode/order-label-barcode-setting",
        permissionFor: "adhocBarcodeGeneration",
        subModule: 27,
    },
];

export const RateCardColumns = [
    { label: 'Company Name', key: 'CompanyName' },
    { label: 'Seller Name', key: 'SellerName' },
    { label: 'Seller Code', key: 'SellerCode' },
    { label: 'Actions', key: '', customClass: 'sticky' }
];

export const TaskListingColumns = [
    { id: 1, label: 'Company / Seller Name', key: 'companySellerName', isSorting: true, customClass: 'taskTitle' },
    { id: 2, label: 'Type', key: 'taskTypeName', isSorting: true },
    { id: 3, label: 'Priority', key: 'taskPriorityName', isSorting: true },
    { id: 4, label: 'Task Id', key: 'id', isSorting: true },
    { id: 5, label: 'Title', key: 'taskTitle', isSorting: true, customClass: 'taskTitle' },
    { id: 6, label: 'Amount', key: 'amount', isSorting: true },
    { id: 7, label: 'SKU', key: 'sku', isSorting: true, customClass: 'smallData' },
    { id: 8, label: 'Quantity', key: 'quantity', isSorting: true },
    { id: 9, label: 'Status', key: 'taskStatusName', isSorting: true, htmlElement: true },
    { id: 10, label: 'Created Date', key: 'createdDate', isDate: true, isSorting: true },
    { id: 11, label: 'Entry Date', key: 'entryDate', isDate: true, isSorting: true },
    { id: 12, label: 'Actions', key: '', customClass: 'sticky' }
];
export const ShopifyOrderColumns = [
    { id: 2, label: 'Type', key: 'taskTypeName', isSorting: true },
    { id: 3, label: 'Priority', key: 'taskPriorityName', isSorting: true },
    { id: 4, label: 'Task Id', key: 'id', isSorting: true },
    { id: 5, label: 'Title', key: 'taskTitle', isSorting: true, customClass: 'taskTitle' },
    { id: 6, label: 'Amount', key: 'amount', isSorting: true },
    { id: 7, label: 'SKU', key: 'sku', isSorting: true },
    { id: 8, label: 'Quantity', key: 'quantity', isSorting: true },
    { id: 10, label: 'Created Date', key: 'createdDate', isDate: true, isSorting: true },
    { id: 11, label: 'Actions', key: '', customClass: 'sticky' }
];

export const TaskListingSellerColumns = [
    { id: 1, label: 'Type', key: 'taskTypeName', isSorting: true },
    { id: 2, label: 'Priority', key: 'taskPriorityName', isSorting: true },
    { id: 3, label: 'Task Id', key: 'id', isSorting: true },
    { id: 4, label: 'Title', key: 'taskTitle', isSorting: true, customClass: 'taskTitle' },
    { id: 5, label: 'Amount', key: 'amount', isSorting: true },
    { id: 6, label: 'SKU', key: 'sku', isSorting: true, customClass: 'smallData' },
    { id: 7, label: 'Quantity', key: 'quantity', isSorting: true },
    { id: 8, label: 'Status', key: 'taskStatusName', isSorting: true, htmlElement: true },
    { id: 9, label: 'Created Date', key: 'createdDate', isDate: true, isSorting: true },
    { id: 10, label: 'Actions', key: '', customClass: 'sticky' }
];

export const UserRequestColumns = [
    { label: 'Full Name', key: 'FullName', isSorting: true, id: 1 },
    { label: 'Email', key: 'Email', isSorting: true, id: 2 },
    { label: 'Phone', key: 'PhoneNumber', isSorting: false, id: 3 },
    { label: 'Secondary Phone', key: 'SecondaryPhoneNumber', isSorting: false, id: 4 },
    { label: 'Signup Reason', key: 'SignupReason', id: 5 },
    { label: 'Company', key: 'CompanyName', isSorting: false, id: 6 },
    { label: 'Country', key: 'Country', isSorting: true, id: 7 },
    { label: 'State', key: 'State', isSorting: true, id: 8 },
    { label: 'City', key: 'City', isSorting: true, id: 9 },
    { label: 'ZipCode', key: 'ZipCode', isSorting: true, id: 10 },
    { label: 'Address 1', key: 'AddressFirst', isSorting: false, id: 11 },
    { label: 'Address 2', key: 'AddressSecond', isSorting: false, id: 12 },
    { label: 'Address 3', key: 'AddressThird', isSorting: false, id: 13 },
    { label: 'Date', key: 'CreatedDate', isSorting: false, id: 14 },
    { label: 'Actions', key: '', id: 15, customClass: 'sticky' },
];

export const PickListColumns = [
    { label: 'Checkbox', key: 'isChecked', id: 1 },
    { label: 'Company/Seller', key: 'companySellerName', isSorting: true, id: 2 },
    { label: 'Orders', key: 'orderCount', type: 'orderDetails', isSorting: true, id: 3 },
    { label: 'Items', key: 'productQuantity', isSorting: true, id: 4 },
    { label: 'Actions', key: '', id: 5 },
];

export const SKUTable = [
    { label: 'Checkbox', key: 'isChecked', id: uuidv4() },
    { label: '[QTY] Ordered SKU', key: 'ProductSKUQuantity', id: uuidv4() },
    { label: 'SKU Count', key: 'SKUCount', id: uuidv4() },
    { label: 'Label Count', key: 'LabelCount', id: uuidv4() },
    { label: 'Actions', key: '', id: uuidv4() },
];

export const ShippedLabelHistoryColumns = [
    { label: 'Checkbox', key: 'isChecked', id: 1 },
    { label: 'Company/Seller', key: 'CompanySellerName', isSorting: true, id: 2 },
    { label: 'SKU', key: 'ProductSKU', isSorting: true, id: 3 },
    { label: 'TotalQuantity', key: 'TotalQuantity', isSorting: true, id: 5 },
    { label: 'Actions', key: '', id: 6 },
];

export const RateCardHistoryColumns = [
    { label: 'Amount', key: 'Amount' },
    { label: 'Additional Charge', key: 'AdditionalCharge' },
    { label: 'Valid From', key: 'ValidFrom' },
    { label: 'Valid To', key: 'ValidTo' }
];

export const RateCardTableColumns = [
    { label: 'Service Type', key: 'companyName' },
    { label: 'Transaction Type', key: 'sellerName' },
    { label: 'Charge Type', key: 'validFrom', isDate: true },
    { label: 'Size', key: 'validTo', isDate: true },
    { label: 'Charge/Unit', key: 'validTo', isDate: true },
    { label: 'Valid From', key: 'validTo', isDate: true },
    { label: 'Valid To', key: 'validTo', isDate: true },
    { label: 'Amount (Charge/Unit)', key: 'validTo', isDate: true },
    { label: 'Additional Charge', key: 'validTo', isDate: true },
    { label: 'Action', key: '' }
];

export const ReturnBulkCardColumns = [
    { label: 'Marketplace', key: 'MarketplaceName' },
    { label: 'Integration Name', key: 'IntegrationName', isSorting: true },
    { label: 'File Name', key: 'FileName', isSorting: true },
    { label: 'Record Uploaded', key: 'ReturnsSubmitted', isSorting: true },
    { label: 'Return Accepted', key: 'ReturnsAccepted', isSorting: true },
    { label: 'Rows Submitted', key: 'RowsSubmitted', isSorting: true },
    { label: 'Date', key: 'UploadedDate', isSorting: true, isDate: true },
    { label: 'Status', key: 'Status' },
];

export const LedgerUnbilled = [
    { label: 'Checkbox', id: 1, isDate: true },
    { label: 'Transaction Mode', key: 'transactionMode', id: 2, width: '20%' },
    { label: 'Transaction Type', key: 'transactionType', id: 3, width: '20%' },
    { label: 'Seller Code', key: 'sellerCode', id: 4, width: '20%' },
    { label: 'Description', key: 'description', id: 5, width: '20%' },
    { label: 'Credit', key: 'credit', id: 6, width: '10%' },
    { label: 'Debit', key: 'debit', id: 7, width: '10%' },
    { label: 'Amount Due', key: 'amount', id: 8, width: '10%' },
    { label: 'Type', key: 'type', id: 9, width: '10%' },
    { label: 'PDF', key: 'htmlElement', id: 10, width: '10%' },
    { label: 'Action', key: '', id: 11, width: '10%' }
];

export const LedgerListing = [
    { label: 'Transaction Date', key: 'entryDate', isDate: true, id: 1, isSorting: true, width: '10%' },
    { label: 'Company/Seller', key: 'companySellerName', id: 2, isSorting: true, width: '20%', customClass: 'fixedDescriptionAccountingCol' },
    { label: 'Transaction Type', key: 'transactionType', id: 4, isSorting: true, width: '20%' },
    { label: 'Credit', key: 'credit', id: 9, width: '10%', isSorting: true, htmlElement: true },
    { label: 'Debit', key: 'debit', id: 10, width: '10%', isSorting: true, htmlElement: true },
    { label: 'Status', key: 'statusName', id: 5, width: '10%', isSorting: true, htmlElement: true },
    { label: 'Payment Mode', key: 'paymentMode', id: 7, width: '10%', isSorting: true },
    { label: 'Currency', key: 'baseCurrencyCode', id: 8, width: '10%', isSorting: true },
    { label: 'Amount', key: 'baseConversionAmount', id: 9, width: '10%' },
    { label: 'Transaction Mode', key: 'transactionMode', id: 11, isSorting: true, width: '20%' },
    { label: 'Description', key: 'description', id: 12, width: '20%', customClass: 'fixedDescriptionAccountingCol' },
    { label: 'Reference', key: 'referenceId', id: 6, width: '10%', isSorting: true, htmlElement: true },
    { label: 'Action', key: '', id: 13, width: '10%', customClass: 'sticky alignRight' }
];
export const SellerLedgerListing = [
    { label: 'Company', key: 'companyName', id: 1, isSorting: true },
    { label: 'Seller', key: 'sellerName', id: 2, isSorting: true },
    { label: 'Total Credit', key: 'totalCredit', id: 3, isSorting: true, htmlElement: true },
    { label: 'Total Debit', key: 'totalDebit', id: 4, isSorting: true, htmlElement: true },
    { label: 'Balance', key: 'balance', id: 5, isSorting: true, htmlElement: true },
    { label: 'Action', key: '', id: 6, className: 'sticky' }
];


export const LedgerBilled = [
    { label: 'Invoice Name', key: 'serviceType', id: 1 },
    { label: 'Billed Date', key: 'transactionType', id: 2 },
    { label: 'Status', key: 'payStatus', id: 3 },
    { label: 'Action', key: '', id: 4 },
];


export const UploadListColumns = [
    { label: 'Name', key: 'IntegrationName', isSorting: true },
    { label: 'File Name', key: 'FileName', isSorting: true },
    { label: 'Order Submitted', key: 'OrderSubmitted', isSorting: true },
    { label: 'Orders Accepted', key: 'OrdersAccepted', isSorting: true },
    { label: 'Rows Submitted', key: 'RowsSubmitted', isSorting: true },
    { label: 'Date', key: 'UploadedDate', isSorting: true, isDate: true },
    { label: 'Status', key: 'Status', isSorting: false, customClass: 'sticky' },
];

export const ProcessReviewColumns = [
    { id:1, label: 'Carrier Tracking', key: 'IntegrationName', isSorting: true },
    { id:2, label: 'Tracking', key: 'FileName', isSorting: true },
    { id:3, label: 'Company/Seller', key: 'OrderSubmitted', isSorting: true },
    { id:4, label: 'Service/Package Type', key: 'OrdersAccepted', isSorting: true },
    { id:5, label: 'Ship Date', key: 'RowsSubmitted', isSorting: true },
    { id:6, label: 'Carrier Trnx Date', key: 'UploadedDate', isSorting: true, isDate: true },
    { id:7, label: 'Carrier Trnx Amount', key: 'UploadedDate', isSorting: true, isDate: true },
    { id:8, label: 'Amount', key: 'UploadedDate', isSorting: true, isDate: true },
    { id:9, label: 'Status', key: 'Status', isSorting: false, customClass: 'sticky' },
];

export const ReconciliationColumns = [
    { id: 1, label: 'Month', key: 'month', isSorting: true, isClickable: true },
    { id: 2, label: 'Matched Tracking IDs', key: 'matchedTrackingNumberCount', isSorting: true, isClickable: true },
    { id: 6, label: 'Disputed Tracking IDs', key: 'disputedTrackingNumberCount', isSorting: true, isClickable: true },
    { id: 3, label: 'Unmatched Tracking IDs', key: 'unMatchedTrackingNumberCount', isSorting: true, isClickable: true },
    { id: 4, label: 'Profit ($)', key: 'profit', isSorting: true, htmlElement: true },
    { id: 5, label: '3PL Margin ($)', key: 'finalMargin', isSorting: true },
    { id: 7, label: 'Total Margin ($)', key: 'totalMargin', isSorting: true },
];

export const CarrierProfitReportsColumns = [
    { id: 1, label: 'Reporting Period', key: 'period', isSorting: true },
    { id: 2, label: 'Count', key: 'labelCreationCount', isSorting: true },
    { id: 3, label: 'Total Spend ($)', key: 'labelPurchased', isSorting: true },
    { id: 4, label: 'Refunded', key: 'labelRefundCount', isSorting: true },
    { id: 5, label: 'Refund Amount ($)', key: 'labelRefund', isSorting: true, htmlElement: true },
    { id: 6, label: 'Adjustment Count', key: 'labelAdjustmentCount', isSorting: true, htmlElement: true },
    { id: 7, label: 'Adjustment Amount ($)', key: 'labelAdjustment', isSorting: true, htmlElement: true },
    { id: 8, label: 'Total Revenue ($)', key: 'totalCollection', isSorting: true, htmlElement: true },
    { id: 9, label: 'Carrier Wallet Credit ($)', key: 'walletBalance', isSorting: true, htmlElement: true },
    { id: 10, label: 'Carrier Closing Balance ($)', key: 'carrierClosingBalance', isSorting: true, htmlElement: true },
    { id: 11, label: 'Carrier Revenue ($)', key: 'carrierRevenue', isSorting: true, htmlElement: true },
    { id: 12, label: 'Net Profit / Loss ($)', key: 'profit', isSorting: true, htmlElement: true },
    // { id: 11, label: 'Currency', key: 'currency', isSorting: true, htmlElement: true }
];

export const ReconciliationDisputedTransactionDetailsColumns = [
    { id: 1, label: 'Date', key: 'createdDate', isSorting: true },
    { id: 2, label: 'Tracking Number', key: 'trackingNumber', isSorting: true },
    { id: 3, label: 'Profit', key: 'profit', isSorting: true },
    { id: 4, label: 'Carrier Rate', key: 'transactionAmount', isSorting: true },
    { id: 5, label: '3PL Rate', key: 'rate', isSorting: true },
    { id: 6, label: 'Carrier Margin', key: 'carrierAdminFee', isSorting: true },
    { id: 7, label: '3PL Margin', key: 'wmsAdminFee', isSorting: true },
]

export const ReconciliationTransactionDetailsColumns = [
    //{ id: 1, label: 'Shipment ID', key: 'shipmentId', isSorting: true },
    { id: 2, label: 'Tracking Number', key: 'trackingNumber', isSorting: true },
    { id: 3, label: 'Created Date', key: 'createdDate', isSorting: true, isDate: true },
    { id: 4, label: 'Company/Seller Name', key: 'companySellerName', isSorting: true },
    { id: 5, label: 'Service Name', key: 'serviceName', isSorting: true },
    { id: 6, label: 'Package Name', key: 'packageName', isSorting: true },
    //{ id: 7, label: 'Order Number', key: 'orderNumber', isSorting: true },
    { id: 8, label: '3PL Amount ($)', key: 'rate', isSorting: true },
    //{ id: 9, label: 'Base Rate ($)', key: 'baseRate', isSorting: true },
    //{ id: 10, label: 'Carrier Admin Fee ($)', key: 'carrierAdminFee', isSorting: true },
    { id: 11, label: 'WMS Admin Fee ($)', key: 'wmsAdminFee', isSorting: true },
    { id: 12, label: 'Carrier Amount ($)', key: 'transactionAmount', isSorting: true },
    { id: 13, label: 'Profit ($)', key: 'profit', isSorting: true },
    //{ id: 13, label: 'Matched', key: 'isMatched', isSorting: true },
];

export const CarrierConnectAssignmentApprovalColumns = [
    { id: 1, label: 'Checkbox', key: 'isChecked' },
    { id: 3, label: 'Thumbnail / Carrier Connect ID', customClass: 'taskTitle', key: 'carrierConnectNumber', isSorting: true, isMultipleLine: true, key2: 'carrierConnectNumber', key1: 'thumbnail' },
    { id: 4, label: 'From Company/Seller', key: 'oldCompanySellerName', isSorting: true, customClass: 'taskTitle' },
    { id: 5, label: 'To Company/Seller', key: 'companySellerName', isSorting: true, customClass: 'taskTitle' },
    { id: 6, label: 'Tracking Number', key: 'trackingNumber', customClass: 'taskTitle', isSorting: true },
    { id: 7, label: 'Carrier Name', key: 'carrierName', isSorting: true },
    { id: 8, label: 'Package Count', key: 'packageCount', customClass: 'smallData', isEditable: true, inputType: 'number', isSorting: true },
    { id: 9, label: 'Status', key: 'statusName', htmlElement: true, isSorting: true },
    { id: 10, label: 'Created Date', key: 'createdDate', isDate: true, isSorting: true },
    { id: 11, label: 'Actions', key: '', customClass: 'sticky' }
];

export const transactionType = [
    {
        label: "Credit",
        value: 12,
        permission: 'all'
    },
    {
        label: "Debit",
        value: 13,
        permission: 'all'
    },
    {
        label: "Credit - VIP Recharge",
        value: 7,
        permission: 'superAdmin'
    },
    {
        label: "Credit - Easy Post Recharge",
        value: 8,
        permission: 'superAdmin'
    },
    {
        label: "Credit - USPS Premium Recharge",
        value: 14,
        permission: 'superAdmin'
    },
];

export const shippingRefList = [
    {
        label: "Product Id",
        value: 'productid',
    },
    {
        label: "Product Title",
        value: 'producttitle',
    },
    {
        label: "Product SKU",
        value: 'productsku',
    },
]

export const ItemTypeList = [
    {
        label: "Bundle",
        value: 1,
    },
    {
        label: "Individual",
        value: 2,
    }
];

export const outboundColumns = ['OutboundId(To_be_left_blank)', 'Row(To_be_left_blank)', 'Status(To_be_left_blank)']

/*Module */
export const orderManagement = 1;
export const addressBook = 2;
export const returnsManagement = 3;
export const accountsManagement = 4;
export const inventoryManagement = 5;
export const settings = 6;
export const barCode = 7;
export const FEATURE_WALLETBALANCEDISPLAY = 8;
export const FEATURE_UPLOADS = 10;
export const FEATURE_TASKMANAGEMENT = 11;
export const FEATURE_CARRIERCONNECTMANAGEMENT = 12;
export const FEATURE_REPORTS = 13;

/* Sub modules */
export const shipmentModule = 1;
export const batchModule = 2;
export const historyModule = 3;
export const scanFormModule = 4;
export const addressModule = 5;
export const packages = 6;
export const products = 7;
export const SUBF_COMPANY = 8;
export const SUBF_SELLER = 9;
export const SUBF_USER = 10;
export const SUBF_LISTING = 11;
export const SUBF_INBOUND = 12;
export const SUBF_OUTBOUND = 13;

export const SUBF_CSVMAPPING = 14;
export const SUBF_FUNDMANAGEMENT = 15;
export const SUBF_RATECARD = 16;
export const SUBF_CSVUPLOAD = 17;
export const SUBF_APIKEYGENERATION = 18;
export const SUBF_SERVICECONFIGIURATION = 19;
export const SUBF_MARKETPLACEINTEGRATION = 20;
export const SUBF_MARGINCONFIGURATION = 21;
export const SUBF_CONFIGURATION = 22;

export const SUBF_BARCODEMAPPING = 23;
export const SUBF_BARCODEUPLOAD = 24;
export const SUBF_BARCODESETTINGS = 25;
export const SUBF_NEWBARCODEGENERATION = 26;
export const SUBF_ADHOCBARCODEGENERATION = 27;
export const SUBF_WALLETBALANCEDISPLAY = 28;
export const SUBF_USERSPERMISSIONS = 29;
export const SUBF_PRODUCTLISTING = 30;
export const SUBF_CARRIERCONNECT = 31;
export const SUBF_PICKER = 33;
export const SUBF_PACKER = 34;

/* Module level */
export const featureModule = 1; //for main module like orders management, Inventory Management
export const featureSubmodule = 2;
export const featureSubmodulePermission = 3;

/* Feature */
export const permssionCreate = 1;
export const permssionView = 2;
export const permssionEdit = 3;
export const permssionDelete = 4;
export const permssionBulkUpload = 5;
export const permssionWalletRecharge = 6;
export const permssionTopUp = 7;
export const permssionAdjustment = 8;
export const permssionViewHistory = 9;
export const permssionThreshold = 10;
export const permssionProcessingFee = 11;
export const permssionGenerate = 12;
export const permssionAPIKeyActive = 13;
export const baseRateCardView = 14;
export const baseRateCardEdit = 15;
export const baseRateCardAdd = 16;
export const sellerRateCardView = 17;
export const sellerRateCardEdit = 18;
export const sellerRateCardAdd = 19;
export const permissionCarrierView = 20;
export const permissionCarrierEdit = 21;
export const permissionSellerCarrierView = 22;
export const permissionSellerCarrierEdit = 23;
export const permissionSellerCarrierServicesView = 24;
export const permissionSellerCarrierServicesEdit = 25;
export const permissionCompanyAssociatedSeller = 27;
export const permissionAssociatedUser = 28;
export const permissionMarkedPickedOutbound = 29;
export const permissionPrintLabel = 30;
export const permissionCreateScanForm = 31;
export const permissionAssociatedWarehouse = 32;

export const phoneRegex = /^\+?[1-9]\d{7,14}$/;

// Carrier Connect Status Constants
export const CARRIER_CONNECT_STATUS = {
    NEW: 1,
    IN_TRANSIT: 2,
    RECEIVING_IN_PROGRESS: 3,
    PARTIALLY_RECEIVED_AT_WAREHOUSE: 4,
    RECEIVED_AT_WAREHOUSE: 5,
    CLOSED: 6
};

// Default Carrier Connect Filter Object
export const DEFAULT_CARRIER_CONNECT_FILTERS = {
    searchKeyword: '',
    pageIndex: 1,
    pageSize: 30,
    totalPages: 1,
    totalRecords: 0,
    sortColumn: 'statusName',
    sortOrder: 'ASCENDING',
    carrierIdList: [],
    connectionStatusIdList: [],
    consignmentStatusIdList: [],
    carrierConnectId: '',
    companySellerName: '',
    trackingNumber: '',
    companyIdList: [],
    sellerIdList: [],
    statusIdList: [],
    showFilter: false,
    fromDate: null,
    toDate: null,
    modifiedFromDate: null,
    modifiedToDate: null
};

export const WEIGHT_UNIT_LB = 1;
export const WEIGHT_UNIT_OZ = 2;
export const WEIGHT_UNIT_KG = 3;
export const WEIGHT_UNIT_GM = 4;

export const InchEnum = 1;
export const CMSEnum = 2;

export const SHOPIFY_MARKETPLACE_CHANNEL_ID = 10002;
export const EBAY_MARKETPLACE_CHANNEL_ID = 10001;


export const dateFilters = [{ name: 'Today', value: '0' }, { name: 'Yesterday', value: '1' }, { name: 'Last 3 Days', value: '3' }, { name: 'Last 7 Days', value: '7' }, { name: 'Last 30 Days', value: '30' }];

export const parseClipboardAddress = (clipboardText) => {
    const lines = clipboardText
        .trim()
        .split(/\r?\n/)
        .map(line => line.replace(/,/g, '').replace(/-?\s*USA$/i, '').trim()) // NOSONAR
        .filter(Boolean); // remove empty lines

    let name = '', addressLine1 = '', addressLine2 = '', cityStateZip = '', city = '', state = '', zip = '', country = '';

    if (lines.length === 4) {
        [name, addressLine1, addressLine2, cityStateZip] = lines;
    } else if (lines.length === 3) {
        [name, addressLine1, cityStateZip] = lines;
    } else if (lines.length === 2) {
        [name, cityStateZip] = lines;
    } else if (lines.length === 1) {
        [cityStateZip] = lines;
    }
    const regex = /^(.*)\s+([A-Z]{2})\s+(\d{5}(?:-\d{4})?)$/i;
    const match = regex.exec(cityStateZip);
    if (match) {
        city = match[1].trim();
        state = match[2].toUpperCase();
        zip = match[3];
    } else {
        city = cityStateZip; // fallback if match fails
    }

    return {
        name,
        addressLine1,
        addressLine2,
        city,
        state,
        zip,
        country // empty string if USA is stripped
    };
};


export const accountMenu = [
    {
        name: "My Dashboard",
        icon: "fa fa-tachometer",
        color: "#0000ff",
        path: "/accounting/dashboard",
        module: FEATURE_UPLOADS,
        subModule: 14,
        id: 1
    },
    {
        name: "Service Rate Card",
        icon: "fa fa-ticket",
        color: "#4BBBD3",
        path: "/accounting/service-rate-card",
        module: settings,
        subModule: 15,
        id: 3
    },
    {
        name: "Ledger Details",
        icon: "fa fa-usd",
        color: "#4BBBD3",
        path: "/accounting/ledger",
        module: settings,
        subModule: 15,
        id: 4
    },
    {
        name: "Seller Ledger",
        icon: "fa fa-user",
        color: "#4BBBD3",
        path: "/accounting/seller-ledger",
        module: settings,
        subModule: 15,
        id: 5
    },
    // {
    //     name: "Rent Reports",
    //     icon: "fa fa-user",
    //     color: "#4BBBD3",
    //     path: "/accounting/rent-list",
    //     module: settings,
    //     subModule: 15,
    //     id: 6
    // }
];

export const RentCalculatorColumns = [
    { label: 'Warehouse', key: 'warehouse' },
    { label: 'Company / Seller', key: 'companySeller' },
    { label: 'Rent Frequency', key: 'rentFrequency' },
    { label: 'Baseline (Fixed) Rent Rate', key: 'baselineRate' },
    { label: 'Variable Rent Rate', key: 'variableRate' },
    { label: 'Total Rate', key: 'totalRate' },
    { label: 'Action', key: '' },
];

export const TransactionLevelView = [
    { label: 'Item', key: 'item' },
    { label: 'Weight', key: 'weight' },
    { label: 'Volume (CFT)', key: 'volume' },
    { label: 'Size', key: 'size' },
    { label: 'Quantity (Units)', key: 'quantity' },
    { label: 'Rate', key: 'rate' }
];